export default "__VITE_ASSET__bad00ecf__"